import { axiosInstance } from "../../../Services";

export const fetchAllBoards = async () => {
  try {
    const res = await axiosInstance.get("/mmhboard/boards");
    return res;
  } catch (error) {
    throw error;
  }
};
